<table class="table">
  <thead>
    <tr>
      <th>{{ "common.productName" | translate }}</th>
      <th style="align-items: start; display: flex">
        {{ "catalog.variant-name" | translate }}
      </th>

      <th>
        {{ "freeGift.freeGifts" | translate }}
      </th>
      <th>{{ "productType.product-type" | translate }}</th>

      <th>{{ "common.total-quantity" | translate }}</th>

      <th>{{ "requestPurchase.sku" | translate }}</th>
    </tr>
  </thead>
  <tbody *ngIf="item">
    <tr *ngFor="let line of orderLines">
      <td>
        <a
          class="button-ghost"
          [routerLink]="['/catalog/products', line.productVariant.product.id]"
        >
          <span class="limit-name">
            {{ line.productVariant.product.name }}
          </span>
          <clr-icon shape="arrow right" />
        </a>
      </td>

      <td class="flex flex-row" style="justify-content: center">
        <div *ngIf="!line.productVariant.product.customFields.freeGifts">
          <a
            class="button-ghost"
            [routerLink]="[
              '/catalog/products',
              line.productVariant.product.id,
              'variants',
              line.productVariant.id
            ]"
          >
            <span class="limit-name">
              {{ line.productVariant.name }}
            </span>
            <clr-icon shape="arrow right" />
          </a>

          <div
            *ngIf="line.productVariant.product.customFields.freeGifts"
            class="freegift-badge button-ghost"
          >
            Free gift <clr-icon shape="shopping-bag" />
          </div>
        </div>

        <div *ngIf="line.productVariant.product.customFields.freeGifts">-</div>
      </td>

      <td>
        <div
          *ngIf="line.productVariant.product.customFields.freeGifts"
          class="flex flex-row"
          style="justify-content: center"
        >
          <a
            class="button-ghost"
            [routerLink]="[
              '/catalog/products',
              line.productVariant.product.id,
              'variants',
              line.productVariant.id
            ]"
          >
            <span class="limit-name">
              {{ line.productVariant.name }}
            </span>
            <clr-icon shape="arrow right" />
          </a>

          <div
            *ngIf="line.productVariant.product.customFields.freeGifts"
            class="freegift-badge button-ghost"
          >
            Free gift <clr-icon shape="shopping-bag" />
          </div>
        </div>

        <div *ngIf="!line.productVariant.product.customFields.freeGifts">-</div>
      </td>

      <td>
        {{
          line.productVariant.product.customFields.productType
            ? line.productVariant.product.customFields.productType.name
            : "*"
        }}
      </td>

      <td>{{ line.orderPlacedQuantity }}</td>

      <td>
        <div>
          {{ line.productVariant.sku }}
        </div>
      </td>
    </tr>
  </tbody>
</table>
